import React from 'react';
import ReactDOM from 'react-dom';
import { FooterApp } from '../components/FooterApp';

const mountNode = document.getElementById('footer-app-root');

ReactDOM.hydrate(<FooterApp />, mountNode);
